import React from 'react';
import SearchPageSidebarSection from './SearchPageSidebarSection';
import { bool } from 'prop-types';

const SECTION_ONE_ITEMS_COUNT = 3;
const SECTION_TWO_ITEMS_COUNT = 5;
const SECTION_THREE_ITEMS_COUNT = 7;

export default function SearchPageSidebarSkeleton({ isMobile }) {
    return (<div
        className={'search-page--sidebar skeleton'}>
        <SearchPageSidebarSection
            isMobile={isMobile}
            skeletonMode={true}
            itemCount={SECTION_ONE_ITEMS_COUNT}>
        </SearchPageSidebarSection>
        <SearchPageSidebarSection
            isMobile={isMobile}
            skeletonMode={true}
            itemCount={SECTION_TWO_ITEMS_COUNT}>
        </SearchPageSidebarSection>
        <SearchPageSidebarSection
            isMobile={isMobile}
            skeletonMode={true}
            itemCount={SECTION_THREE_ITEMS_COUNT}>
        </SearchPageSidebarSection>
    </div>);
}

SearchPageSidebarSkeleton.propTypes = { 
    isMobile: bool,
};